import React from 'react';
import { Paper, Table, TableBody, TableHead, TableCell, TableSortLabel, TablePagination, TableRow, Checkbox } from '@material-ui/core';
import { useTableStyle } from '../../utils_v2/materialStyles';
import {getLocalStorageInfo } from '../../utils_v2';
import { STableLoader } from '../loaders';
export default function TableListComp({bulkOperation=false, bulkFlag, heads, noRecord, data, sort='', sort_by='', pagination={}, onChangePage, onChangeRowsPerPage, createSortHandler, classNames, toggleBulkOps, rowTitle, maxheight, height, xScroll,loader,disabled=false,checkboxStyle,tableaCellStyle}){
  const classes = useTableStyle();
  return(
    <div style={{clear: 'both', minWidth:'100%', marginBottom:xScroll?'10px':'0px', width:xScroll?'max-content':'100%'}}>
      <Paper>
      <div className={classes.tableWrapper} style={{height:height ? height :(window.innerHeight - 175) + 'px', overflow: 'auto', maxHeight: maxheight ? maxheight : (window.innerHeight - 175) + 'px'}}>
          <Table
            className={classes.table + ' mui-styled-table ' + classNames}
            aria-labelledby="tableTitle"
            stickyHeader={true}
            size='medium'
          >
            <TableHead className="mui-table">
            {rowTitle && getLocalStorageInfo().defaultLessor.id === 442 ?
              <TableRow className="row-head">
                <p className="row-title">{rowTitle}</p>
              </TableRow> : null}
              <TableRow>
                { bulkOperation ?
                  <TableCell style={checkboxStyle?checkboxStyle:{}}>
                    <Checkbox
                      size="small"
                      checked={bulkFlag}
                      disabled={disabled}
                      onChange={(e) => toggleBulkOps(e.target.checked)}
                      name="bulk_operation"
                      color="primary"
                    />
                  </TableCell>:null
                }
                {heads.map((row, index) =>
                  <TableCell
                    key={index}
                    align={row.actionCell ? 'right':'left'}
                    padding={'default'}
                    sortDirection={sort === row.id ? (sort_by ? sort_by:'asc') : false}
                    style={row.tableaCellStyle?row.tableaCellStyle:{}}
                  >
                    {row.sortOption && noRecord === null ?
                      <TableSortLabel
                        active={sort === row.id}
                        direction={sort_by && sort === row.id ? sort_by:'asc'}
                        onClick={() => createSortHandler(row.id)}
                      >
                        <div style={{ minWidth: row.width ? row.width :''}}>{row.label}</div>
                      </TableSortLabel>:<span><div style={{ minWidth: row.width ? row.width :''}}>{row.label}</div></span>
                    }
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              { noRecord ? <TableRow><TableCell colSpan={bulkOperation ? heads.length+1:heads.length} align="center">{noRecord}</TableCell></TableRow>:data}
            </TableBody>
          </Table>
           {loader?<STableLoader count={6}/>:null}
        </div>
        { pagination && Object.keys(pagination).length && pagination.total > 0 ?
            <TablePagination
              rowsPerPageOptions={[10, 20, 50, 100, 200, 300, 400, 500]}
              component="div"
              count={pagination.total}
              rowsPerPage={pagination.per_page}
              page={pagination.page - 1}
              backIconButtonProps={{'aria-label': 'previous page'}}
              nextIconButtonProps={{'aria-label': 'next page'}}
              onChangePage={onChangePage}
              onChangeRowsPerPage={onChangeRowsPerPage}
            />:null
        }
      </Paper>
    </div>
  )
}
